
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/features/video-chat",
      function () {
        return require("private-next-pages/[lang]/features/video-chat.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/features/video-chat"])
      });
    }
  